<template>
	<bbox-collapse ref="collapse">
		<div ref="contextBanner" class="bbox-context-banner" :class="{ open }">
			<bbox-card :class="[computedCardClasses]">
				<div class="display-inline-block margin-right-normal" v-if="$slots.icon">
					<!-- @slot Slot para icone -->
					<slot class="display-inline-block margin-right-normal" name="icon"></slot>
				</div>
				<div class="display-inline-block" v-if="$slots.text">
					<!-- @slot Slot para texto -->
					<slot name="text"></slot>
				</div>
				<div class="display-inline-block margin-left-normal" v-if="$slots.button">
					<!-- @slot Slot para botão de ação -->
					<slot name="button"></slot>
				</div>
			</bbox-card>
		</div>
	</bbox-collapse>
</template>

<script>
import BboxCard from './Card';
import BboxCollapse from './Collapse';
export default {
	name: 'b-context-banner',
	mounted() {
		if (this.open) this.$refs.collapse.expand();
		else this.$refs.collapse.collapse();
	},
	updated() {
		if (this.open) this.$refs.collapse.expand();
		else this.$refs.collapse.collapse();
	},
	components: {
		BboxCard,
		BboxCollapse
	},
	props: {
		/**
		 * Classes para aplicar no card interno
		 */
		cardClasses: String,
		/**
		 * Se deve iniciar aberto ou não
		 */
		startOpen: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			open: this.startOpen
		};
	},
	computed: {
		computedCardClasses() {
			if (this.cardClasses) return this.cardClasses;
			return 'padding-vertical-normal padding-horizontal-big bg-white-darker-2 ink-lighter-1 align-center';
		}
	},
	methods: {
		/**
		 * Fecha/abre o context banner
		 * @public
		 */
		toggleContextBanner() {
			this.open = !this.open;
		},
		/**
		 * Abre o context banner
		 * @public
		 */
		showContextBanner() {
			this.open = true;
		},
		/**
		 * Fecha o context banner
		 * @public
		 */
		hideContextBanner() {
			this.open = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.card {
	border-radius: 5px;
	box-shadow: none;
}
.bbox-context-banner {
	box-sizing: border-box;
	span.icon-wrapper.close-context-banner {
		justify-self: flex-end;
		margin-right: -4px;
		margin-left: auto;
		cursor: pointer;
		padding: 4px;
	}
	.bbox-card {
		box-sizing: border-box;
		display: flex;
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-items: center;
		flex-direction: row;
		min-height: 5rem;
		button {
			margin-left: auto;
			margin-right: 0;
			margin-top: 0;
			margin-bottom: 0;
		}
		.icon-wrapper {
			margin: 0;
			margin-right: 1.4375rem;
		}
		p.important {
			text-align: left;
			margin-top: 0;
			margin-bottom: 0;
		}
	}
}
</style>

<docs>
    Banner de contexto

    As importações dos arquivos abaixo são necessárias para o funcionamento do componente:
    - styling.scss
    - spacing.scss

    ```js

    <span style="cursor: pointer;" @click="$refs.ctxbanner1.toggleContextBanner()"> Fechar/abrir context banner </span>
    <b-context-banner ref="ctxbanner1">
        <p class="margin-0" slot="text">Texto do context banner</p>
    </b-context-banner>


    <b-context-banner :start-open="true" card-classes="padding-vertical-normal padding-horizontal-big bg-red-base white-base align-center" ref="ctxbanner2">
        <p class="margin-0" slot="text">Context banner pré-aberto, utilizando prop card-classes</p>
    </b-context-banner>

    ```
</docs>
